import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@STORE/index';

import { 
    documentStructureHelpModalSlice, 
    DocumentStructureHelpModalState,
} from '@REDUCERS';

function createDocumentStructureHelpModalHook() {
    return function useDocumentStructureHelpModal(equalityFn?: EqualityFn<DocumentStructureHelpModalState>) {
        const state = useAppSelector((store) => store.documentStructureHelpModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: () => dispatch(documentStructureHelpModalSlice.actions.open()),
            close: () => dispatch(documentStructureHelpModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createDocumentStructureHelpModalHook(); 